<template>
    <van-tabs v-model="curCar"  @click="tabClick" >
        <van-tab v-for="(itm,idx) in cars" :key="idx" :title="itm.name" />
    </van-tabs>
</template>

<script>
import { 
    Tab, 
    Tabs 
} from 'vant'
import { refreshCars } from '@/utils/localutils'
import { CarApi } from '@/api/car'

export default {
    name: 'CarTabs',
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs
    },
    data() {
        return {
            curCar: 0,
            cars: []
        }
    },
    mounted(){
        refreshCars()
        var that = this
        that.axios.get(CarApi).then((ret) => {
            if (ret.flag) {
                const cars = ret.details
                console.log(cars)
                if (cars != null ) { 
                    const tmpCars = cars
                    console.log(tmpCars.length)
                    if (tmpCars.length == 0) {
                        that.cars.push({
                            id: 0,
                            name: '所有'
                        })
                    } else if (tmpCars.length == 1) {
                        that.curCar = tmpCars[0].id
                        that.cars.push({
                            id: tmpCars[0].id,
                            name: tmpCars[0].area_name + tmpCars[0].code
                        })
                    } else if (tmpCars.length > 1) {
                        that.cars.push({
                            id: 0,
                            name: '所有'
                        })
                        console.log(that.cars)
                        tmpCars.forEach(item => {
                            that.cars.push({
                                id: item.id,
                                name: item.area_name + item.code
                            }) 
                        })
                        that.curCar = 0
                        console.log(that.cars)
                    }
                    console.log(that.cars)
                }
            }
        })
    },
    methods: {
        tabClick(sort) {
            if (this.cars.length > sort) {
                this.$emit('tabClick',this.cars[sort])
            }
        }
    }
}
</script>
